var _rect, _path, _path2, _g, _path3, _g2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgClubone = function SvgClubone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "url(#uh5dmrr1ma)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mu7bcpgpjb",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -8,
    y: 0,
    width: 60,
    height: 52
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 26c0 14.36-11.64 26-26 26C0 52 0 52 0 26S0 0 26 0c14.36 0 26 11.64 26 26z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-7.704 0h34.667v52H-7.704V0z",
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mu7bcpgpjb)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#7yt1324h5c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.444a3.704 3.704 0 0 1 3.704-3.703h51.852a3.704 3.704 0 0 1 3.703 3.703v31.111a3.704 3.704 0 0 1-3.703 3.704H3.704A3.704 3.704 0 0 1 0 41.556V10.444z",
    fill: "#A0AAAF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.103 13.056c.55 0 1.054.182 1.456.487l.378-.396a2.963 2.963 0 0 0-1.834-.629c-1.612 0-2.918 1.266-2.918 2.827s1.306 2.827 2.918 2.827c.695 0 1.332-.236 1.834-.628l-.392-.387c-.4.298-.9.478-1.442.478-1.305 0-2.363-1.025-2.363-2.29 0-1.264 1.058-2.29 2.363-2.29zm26.005 3.11L31 12.584H29.86v5.495h1.24v-3.58l3.057 3.58h1.187v-5.495h-1.236v3.582zm3.144.906V15.73h1.565v-.987h-1.565v-1.172h2.705v-.987h-3.87V18.1h3.928v-1.028h-2.763zm-16.942-1.97c.578.21.99.751.99 1.384v.13c0 .814-.683 1.477-1.524 1.477h-1.83V12.6h1.246c.84 0 1.524.662 1.524 1.476v.024c0 .387-.154.739-.406 1.002zm-1.779-.093h.661c.518 0 .939-.408.939-.91v-.023c0-.502-.421-.91-.939-.91h-.661v1.843zm2.184 1.477c0-.502-.42-.91-.939-.91h-1.245v1.949h1.245c.518 0 .94-.408.94-.909v-.13zm-3.951-.216c0 .752-.605 1.364-1.349 1.364h-.033a1.358 1.358 0 0 1-1.348-1.364v-3.664h-.586v3.664c0 1.065.868 1.932 1.934 1.932h.033a1.935 1.935 0 0 0 1.934-1.932v-3.664h-.585v3.664zm-5.704-3.664h-.586v5.473h2.816v-.601h-2.23v-4.872zm15.283-.088c1.612 0 2.918 1.266 2.918 2.827s-1.306 2.827-2.918 2.827c-1.611 0-2.917-1.266-2.917-2.827 0-1.56 1.306-2.827 2.917-2.827zm0 4.55c.998 0 1.807-.785 1.807-1.751 0-.967-.809-1.75-1.807-1.75-.997 0-1.806.783-1.806 1.75 0 .966.809 1.75 1.806 1.75z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.852 6.985a3.686 3.686 0 0 1 2.407 3.46v15.4H43.474c0-8.69 5.578-16.082 13.378-18.86zM55.556 45.26c.607 0 1.177-.163 1.681-.422-8-2.667-13.763-10.156-13.763-18.985 0 9.348-6.46 17.2-15.192 19.407h27.274z",
    fill: "#EEF1F1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "apfykxhuod",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 6,
    width: 30,
    height: 40
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.963 10.444a3.704 3.704 0 0 1 3.704-3.703h21.037a3.704 3.704 0 0 1 3.703 3.703v31.111a3.704 3.704 0 0 1-3.703 3.704H30.667a3.704 3.704 0 0 1-3.704-3.703V10.444z",
    fill: "#A0AAAF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#jf45pru7ie)",
    mask: "url(#apfykxhuod)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#D6DFDF",
    fillOpacity: 0.01
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "7yt1324h5c",
    x: 0,
    y: 4.741,
    width: 67.259,
    height: 46.519,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2520_85199"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2520_85199",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "jf45pru7ie",
    x: -1,
    y: 0,
    width: 55,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_2520_85199"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uh5dmrr1ma",
    x1: 0,
    y1: 26,
    x2: 52,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6DFDF"
  })))));
};

export default SvgClubone;